import * as Sentry from '@sentry/nuxt';

import type { ProfileState, Profile } from '@/types/models/profile.model';

export const useProfileStore = defineStore('Profile / Me', {
  // The state function returns an object
  state: (): ProfileState => ({
    profile: null,
    isLoading: false,
    error: null
  }),

  // Define getters if needed
  getters: {
    fullName(state): string {
      return state.profile
        ? `${state.profile.first_name} ${state.profile.last_name}`
        : '';
    }
  },

  // Define actions for the store
  actions: {
    async fetchProfile() {
      this.isLoading = true;
      this.error = null;
      const runtime = useRuntimeConfig();

      try {
        const authStore = useAuthStore();

        const response = await authStore.authFetch(
          runtime.public.meService + '/profile'
        );
        if (response.status !== 200) {
          throw new Error('failed to fetch from me/profile');
        }

        const body: Profile = await response.json();
        this.profile = body;
      } catch (err: any) {
        this.error = err.message;
        Sentry.captureException(err, {
          tags: { component: 'ProfileStore', action: 'fetchProfile' },
          extra: { type: 'store_error' }
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useProfileStore, import.meta.hot));
}
